module.exports = __webpack_public_path__ + "img/foam-mobile_521a16a4b6e5488409f41f1ae4882d13.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/foam-mobile.jpg
// module id = 280
// module chunks = 0